export default "__VITE_ASSET__3394bd26__"